module.exports = __webpack_public_path__ + "img/電気回路_1_2_3.40274832.png";